export default "__VITE_ASSET__fb58912c__"